import { Box, Button, Typography } from '@mui/material';
import { ReactNode } from 'react';
import DesignSystem from '../../designSystem';

export function EmptyState({
  icon,
  title,
  body,
  actionLabel,
  onAction,
}: {
  icon?: ReactNode;
  title: string;
  body?: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 7,
        px: 2,
        color: DesignSystem.colors.textSecondary,
      }}
    >
      {icon && (
        <Box sx={{ mb: 1.5, opacity: 0.5, color: DesignSystem.colors.textPrimary, '& svg': { fontSize: 44 } }}>{icon}</Box>
      )}
      <Typography
        sx={{
          fontSize: 17,
          fontWeight: 700,
          letterSpacing: '-0.02em',
          color: DesignSystem.colors.textPrimary,
          mb: body ? 0.75 : 0,
        }}
      >
        {title}
      </Typography>
      {body && (
        <Typography sx={{ fontSize: 14, color: DesignSystem.colors.textSecondary, mb: actionLabel ? 2.5 : 0 }}>
          {body}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button
          variant="contained"
          onClick={onAction}
          sx={{
            textTransform: 'none',
            boxShadow: 'none',
            fontWeight: 700,
            borderRadius: DesignSystem.borderRadius.pill,
            px: 2.5,
            bgcolor: DesignSystem.colors.action,
            '&:hover': { bgcolor: DesignSystem.colors.actionDark, boxShadow: 'none' },
          }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}

export default EmptyState;
